import {type ReactNode} from 'react';

const LINK_PATTERN = /(https?:\/\/[^\s<>]+|[\w.+-]+@[\w-]+(?:\.[\w-]+)+)/g;
const TRAILING_PUNCTUATION = /[.,;:!?)\]'"”’]+$/;

/**
 * Splits plain text into nodes, wrapping URLs in links and emails in
 * `mailto:` links. Trailing sentence punctuation is kept out of the href.
 */
export function linkifyText(text: string): ReactNode[] {
  const nodes: ReactNode[] = [];
  let lastIndex = 0;

  for (const match of text.matchAll(LINK_PATTERN)) {
    const start = match.index;
    const value = match[0].replace(TRAILING_PUNCTUATION, '');
    const isUrl = value.startsWith('http');

    if (start > lastIndex) {
      nodes.push(text.slice(lastIndex, start));
    }

    nodes.push(
      <a
        className="text-primary underline"
        href={isUrl ? value : `mailto:${value}`}
        key={`${start}-${value}`}
        rel={isUrl ? 'noopener noreferrer' : undefined}
        target={isUrl ? '_blank' : undefined}
      >
        {value}
      </a>
    );

    lastIndex = start + value.length;
  }

  nodes.push(text.slice(lastIndex));

  return nodes;
}
